var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-07-11
 * @brief EHP 진단점검 Report - 진단점검 Report 결과 개발
 *
 ********************************************************************/
import React, { useState, useEffect, useRef } from "react";
import ECharts from 'echarts-for-react';
//
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useSetRecoilState, useResetRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { itemState, checkStep, tempCheckValue, doneAssessmentState } from '../../../recoil/assessmentState';
//
import { useTrans } from "../../../utils/langs/useTrans";
//utils
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 진단점검 Report 결과 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ItemCheckResult(props) {
    //trans
    const t = useTrans();
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const curItem = useRecoilValue(itemState);
    const setRecoilCurItem = useSetRecoilState(itemState);
    const resetRecoilTsItemCheckListInfo = useResetRecoilState(doneAssessmentState);
    const setCurCheckStep = useSetRecoilState(checkStep);
    const setRecoilTempCheckVal = useSetRecoilState(tempCheckValue);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    //
    const [checkResult, setCheckResult] = useState(null);
    const { company, zone, subZone, room, spg } = props.curTreeData;
    //
    const isOpen = (props.hasOwnProperty("isOpen")) ? props.isOpen : false;
    const setParentResultOpen = props.setResultOpen;
    const item = props.curHistoryInfo;
    //
    const assessmentId = props.assessmentId;
    // clog("IN ITEMCHECKHISTORYRESULT : assessmentId : " + assessmentId + " : OPEN : " + isOpen);
    const [checkName, setCheckName] = useState("");
    const [shareOn, setShareOn] = useState(false);
    //점검결과 API\  //  clog("IN EHCCHEKRESULT : INIT : " + curItem.ehcType);  //  clog("IN EHCCHEKRESULT : INIT : " + curItem.assessment.assessmentId);
    const chartWidth = window.innerWidth / 8 * 0.781;
    const [isMobile, setIsMobile] = useState(false);
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientWidth <= 430)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientWidth <= 430)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
    });
    const { data: data, isLoading } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: `/api/v2/assessment/${assessmentId}`,
        //appPath: '/api/v2/assessment/66',
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: assessmentId
    });
    useEffect(() => {
        if (data) {
            // clog("IN EHCRESULT : RETURN : " + JSON.stringify(curItem));
            if (data.codeNum == CONST.API_200) {
                //clog("IN EHCRESULT : RETURN : " + JSON.stringify(data.body));
                setCheckResult(data.body);
                // setComment(data.body.alarmDto.description)
            }
            else { // api if
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data]);
    // PDF 다운로드
    function onClickReportDownload(e, reportId) {
        return __awaiter(this, void 0, void 0, function* () {
            //alert("selected-data : " + selectedPeriod);
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/report/${reportId}`,
                "appQuery": {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN COMUTILS : GET FILEDOWNLOAD : " + JSON.stringify(data));
                    //HttpUtil.fileDownload(`${item.itemReportDtoOut.itemName}_진단점검리포트.PDF`, data.body.fileLink);
                    //20221020 jhpark 수정, pdf 이슈 해결 안되면 다시 수정 예정
                    HttpUtil.fileDownload(`${item.itemReportDtoOut.itemName}_진단점검리포트.PDF`, data.body.fileLink);
                }
                else {
                }
            }
        });
    }
    const totalScore = (checkResult == null) ? -1 : (checkResult.hasOwnProperty("totalScore")) ? checkResult.totalScore : -1; // totalAPI
    const alarmDto = (checkResult == null) ? null : (checkResult.hasOwnProperty("alarmDto")) ? checkResult.alarmDto : null; // AlarmAPI
    const checkGroupValue = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkGroupValueDtoList")) ? checkResult.checkGroupValueDtoList : null;
    const checkAvgValue = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkAvgValueDtoList")) ? checkResult.checkAvgValueDtoList : null;
    const checkValueList = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkValueDtoMap")) ? checkResult.checkValueDtoMap : null;
    const stepName = (checkResult == null) ? null : (checkResult.hasOwnProperty("stepName")) ? checkResult.stepName : null; // stepName
    const updatedTime = (checkResult == null) ? null : (checkResult.hasOwnProperty("updatedTime")) ? checkResult.updatedTime : null; // updateTime
    const itemName = (item == null) ? null : (item.hasOwnProperty("itemReportDtoOut")) ? item.itemReportDtoOut.itemName : null; // itemName
    const responsible = (item == null) ? null : (item.hasOwnProperty("itemReportDtoOut")) ? item.itemReportDtoOut.responsible : null; // responsible
    const serialNo = (item == null) ? null : (item.hasOwnProperty("itemReportDtoOut")) ? item.itemReportDtoOut.serialNo : null; // serialNo
    const roomName = (item == null) ? null : (item.hasOwnProperty("roomName")) ? item.roomName : null; // roomName
    const spgName = (item == null) ? null : (item.hasOwnProperty("spgDto")) ? item.spgDto.name : null; // spg
    const reportId = (item == null) ? null : (item.hasOwnProperty("reportId")) ? item.reportId : null; // spg
    // ECahrt , data 반시계 반향으로 적용
    const option = {
        color: [
            "rgba(144, 159, 183, 0.5)",
            "#FF6781",
            "#5B71EF", // VCB 평균 점수 Data
            // "#FF917C"
        ],
        // 차트 하단 정보
        legend: {
            bottom: "12",
            // right: "10",
            // width: "100",
            // itemGap: 9,
            itemWidth: 14,
            itemHeight: 9,
            align: "auto",
            /*      data: [
                   {
                     //  icon: "image://./static/* 개발 서버 /asset/ 배포용
                     icon: "image://./static/img/icon_legend_gray.png",
                     name: "배점",
                     textStyle: {
                       fontFamily: "Noto Sans KR",
                       fontWeight: 400,
                       fontSize: 11,
                       color: "#2A2C2F",
                       padding: [0, 0, 0, 4],
                     },
                   },
                   {
                     icon: "image://./static/img/icon_legend_red.png",
                     name: "평가점수",
                     textStyle: {
                       fontFamily: "Noto Sans KR",
                       fontWeight: 400,
                       fontSize: 11,
                       color: "#2A2C2F",
                       padding: [0, 0, 0, 4],
                     },
                   },
                   {
                     icon: "image://./static/img/icon_legend_purple.png",
                     //name: "VCB 평균점수",
                     name: `${spgName} 평균점수`,
                     textStyle: {
                       fontFamily: "Noto Sans KR",
                       fontWeight: 400,
                       fontSize: 11,
                       color: "#2A2C2F",
                       padding: [0, 0, 0, 4],
                     },
                   },
                 ], */
        },
        // 점수 나오게하는 곳 
        tooltip: {
            position: ['50%', '50%']
        },
        radar: [
            {
                indicator: [
                    // status 정보에 따라 변함...
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 1) || !checkGroupValue[0].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[0].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 2) || !checkGroupValue[1].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[1].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 3) || !checkGroupValue[2].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[2].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 4) || !checkGroupValue[3].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[3].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 5) || !checkGroupValue[4].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[4].checkGroupName, color: "black" },
                ],
                // 배경 간격
                splitNumber: 1,
                // 차트 max  
                radius: 100,
                // startAngle: 90,
                //radar 사이 box style
                splitArea: {
                    areaStyle: {
                        color: ["#FFF", "#FFF"],
                    },
                },
                // 구분선 색상
                axisLine: {
                    lineStyle: {
                        // color: '#2A2C2F'
                        color: "#C3CBD8",
                    },
                },
                // 배경 라인 색상
                splitLine: {
                    lineStyle: {
                        color: "#C3CBD8",
                    },
                },
                // 배경 font
                axisName: {
                    fontWeight: 500,
                    fontFamily: "Noto Sans KR",
                    fontSize: (isMobile) ? 12 : 16
                }
            },
        ],
        series: [
            {
                type: "radar",
                emphasis: {
                    lineStyle: {
                        width: 4,
                    },
                },
                data: [
                    {
                        value: [20, 20, 20, 20, 20],
                        name: "배점",
                        symbol: "circle",
                        symbolSize: 6,
                    },
                    {
                        value: [
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 1) || !checkGroupValue[0].hasOwnProperty("value")) ? -1 : checkGroupValue[0].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 2) || !checkGroupValue[1].hasOwnProperty("value")) ? -1 : checkGroupValue[1].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 3) || !checkGroupValue[2].hasOwnProperty("value")) ? -1 : checkGroupValue[2].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 4) || !checkGroupValue[3].hasOwnProperty("value")) ? -1 : checkGroupValue[3].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 5) || !checkGroupValue[4].hasOwnProperty("value")) ? -1 : checkGroupValue[4].value,
                        ],
                        name: "평가점수",
                        symbol: "circle",
                        symbolSize: 6,
                        //내부 style
                        areaStyle: {
                            // 투명도
                            opacity: 0.1
                        },
                    },
                    {
                        value: [
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 1) || !checkAvgValue[0].hasOwnProperty("value")) ? -1 : checkAvgValue[0].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 2) || !checkAvgValue[1].hasOwnProperty("value")) ? -1 : checkAvgValue[1].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 3) || !checkAvgValue[2].hasOwnProperty("value")) ? -1 : checkAvgValue[2].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 4) || !checkAvgValue[3].hasOwnProperty("value")) ? -1 : checkAvgValue[3].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 5) || !checkAvgValue[4].hasOwnProperty("value")) ? -1 : checkAvgValue[4].value,
                        ],
                        //name: "VCB 평균점수",
                        name: `${spgName} 평균점수`,
                        symbol: "circle",
                        symbolSize: 6,
                        //내부 style
                        areaStyle: {
                            // 투명도
                            opacity: 0.1
                        },
                    },
                ],
            },
        ],
    };
    function onClickEhcInfo(e) {
        var divEhcInfo = document.querySelector(".ehc__info");
        var ulEhcInfo = "";
        for (var i = 0; i < divEhcInfo.children.length; i++) {
            var child = divEhcInfo.children[i];
            if (child.tagName == "UL")
                ulEhcInfo = child;
        }
        if (CUTIL.isnull(ulEhcInfo))
            return;
        ulEhcInfo.classList.toggle("on");
    }
    // 우측 메뉴 이벤트
    function resultOpen(e) {
        const targetElement = e.target;
        const ehcScoreBox = targetElement.closest(".ehc__score");
        if (CUTIL.isnull(ehcScoreBox))
            return;
        // clog("resultOpen : " + ehcScoreBox.className);
        if (ehcScoreBox.classList.contains("close")) {
            ehcScoreBox.classList.remove("close"); // open
        }
        else {
            ehcScoreBox.classList.add("close"); // close
        }
    }
    // by sjpark 20220708
    function handleResultOpen(e, openVal) {
        clog("IN ITEMCHECKRESULT : handleResultOpen : " + openVal);
        setParentResultOpen(!openVal);
    }
    function onSharePop(e) {
        if (shareOn === false) {
            setShareOn(true);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { ref: mobileRef, className: `box ehc__score ${(stepName === "NORMAL") ? "ehc-n" : (stepName === "PREMIUM") ? "ehc-p" : (stepName === "ADVANCED") ? "ehc-a" : "ehc-b"} ${(isOpen) ? "" : "close"}` },
            React.createElement("div", { className: "box__header" },
                React.createElement("p", { className: "box__title" },
                    React.createElement("button", { type: "button", className: "btn btn-box ", onClick: (e) => handleResultOpen(e, isOpen) },
                        React.createElement("span", { className: "hide" }, "\uBA54\uB274\uC811\uAE30\uD3BC\uCE58\uAE30")),
                    React.createElement("span", { className: "cate" },
                        stepName,
                        " ",
                        React.createElement("span", null, "e-HC"))),
                React.createElement("div", { className: "box__etc" },
                    React.createElement("span", { className: "date" }, CUTIL.utc2time("YYYY-MM-DD", updatedTime)))),
            React.createElement("div", { className: "box__body" },
                React.createElement("div", { className: "ehc__info" },
                    React.createElement("p", { className: "ehc__name" }, itemName),
                    React.createElement("ul", { onClick: (e) => onClickEhcInfo(e) },
                        React.createElement("li", null,
                            React.createElement("span", null, t("FIELD.시리얼번호")),
                            React.createElement("span", null, serialNo)),
                        React.createElement("li", null,
                            React.createElement("span", null, t("FIELD.담당자")),
                            React.createElement("span", null, responsible)),
                        React.createElement("li", null,
                            React.createElement("span", null, t("FIELD.위치")),
                            React.createElement("span", null, roomName)))),
                React.createElement("div", { className: "ehc__detail ehc__result" },
                    React.createElement("div", { className: "result__txt" },
                        React.createElement("p", { className: 
                            /*(alarmDto.alarmStatus == "SAFETY") ? "tit " : "tit caution"*/
                            `tit ${(alarmDto != null) ? (alarmDto.alarmStatus == "SAFETY") ? "" : "caution" : "caution"}` },
                            React.createElement("span", null, "\uC885\uD569\uC810\uC218")),
                        React.createElement("p", { className: "score" }, totalScore),
                        React.createElement("p", { className: "txt" }, (alarmDto != null) ? alarmDto.description : "-------------------------------------------X")),
                    React.createElement("div", { className: "scrollH" },
                        React.createElement("div", null,
                            React.createElement("div", { className: "chart", style: { "width": "100%", "margin": "0 auto" } },
                                React.createElement("div", { id: "radar", style: { "height": "300px" } },
                                    React.createElement(ECharts, { option: option, className: "bottom  h300" })))),
                        ((checkGroupValue != null) && (checkValueList != null)) && checkGroupValue.filter(group => checkValueList.hasOwnProperty(group.checkGroupName)).map((name, idx) => (React.createElement("div", { className: "ma__score", key: idx },
                            React.createElement("p", { className: "tit" }, name.checkGroupName),
                            React.createElement("ul", { className: "score__info" }, ((checkValueList != null) && (checkValueList.hasOwnProperty(name.checkGroupName))) && checkValueList[name.checkGroupName].map((list) => (React.createElement("li", { key: list.checkItemId, className: (list.isChecked) ? "disabled" : "" },
                                React.createElement("p", { className: "tit" },
                                    React.createElement("span", null, list.checkItemName)),
                                React.createElement("ul", { className: (list.isChecked) ? "icon-score" : "icon-score score" + ((list.value == 0) ? 1 : (list.value == 1) ? 2 : (list.value == 2) ? 3 : (list.value == 3) ? 4 : (list.value == 4) ? 5 : "") },
                                    React.createElement("li", null, "Bad"),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "\uB9E4\uC6B0\uB098\uC068")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "\uB098\uC068")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "\uBCF4\uD1B5")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "\uC88B\uC74C")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "\uB9E4\uC6B0\uC88B\uC74C")),
                                    React.createElement("li", null, "Good"))))))))))),
                React.createElement("div", { className: "tbl__bottom" },
                    React.createElement("ul", { className: "btn__wrap" },
                        React.createElement("li", null,
                            React.createElement("button", { type: "button", className: "btn-share", onClick: (e) => onSharePop(e) },
                                React.createElement("span", null, t("LABEL.진단결과공유")))),
                        React.createElement("li", null,
                            React.createElement("button", { type: "button", className: "btn-checkpop", "data-pop": "pop-check", onClick: (e) => onClickReportDownload(e, reportId) },
                                React.createElement("span", null, "PDF Download"))))),
                React.createElement(SharePop, { shareOn: shareOn, setShareOn: setShareOn, reportId: reportId, item: item })))));
}
export default ItemCheckResult;
function SharePop(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const shareOn = props.shareOn;
    const setShareOn = props.setShareOn;
    const reportId = props.reportId;
    const item = props.item;
    //
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    function shareClose(e) {
        if (shareOn === true) {
            setShareOn(false);
        }
        setToMails("");
    }
    function handleSetUserId(e) {
        setErrorList(errorList.filter((err) => (err.field !== "toMails")));
        setToMails(e.target.value);
    }
    // fileLInk API
    function emailShare(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (CUTIL.isnull(reportId))
                return;
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/report/${reportId}`,
                "appQuery": {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const fileLink = `${window.location.origin}${CONST.URL_COMM_PDFVIEWER}?${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFNM}=${item.itemReportDtoOut.serialNo}_진단점검리포트.PDF&${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFID}=${data.body.fileLink}`;
                    linkShare(fileLink);
                }
            }
        });
    }
    function linkShare(fileLink) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/report/email`,
                "appQuery": {
                    toMails: [toMails],
                    fileLink: fileLink,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("메일 전송이 완료되었습니다.");
                    setShareOn(false);
                    setToMails("");
                }
                else {
                    if (toMails == "") {
                        setErrorList([{ field: "toMails", msg: "필수 항목입니다." }]);
                    }
                    else {
                        setErrorList(data.body.errorList);
                    }
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-share", className: `popup-boxin ${(shareOn) ? "on" : ""}` },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "\uC9C4\uB2E8\uACB0\uACFC \uACF5\uC720"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => shareClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("ul", { className: "form__input w85p" },
                        React.createElement("li", { className: "center" },
                            React.createElement("p", { className: "tit" }, "E-Mail"),
                            React.createElement("div", { className: "input__area w260" },
                                React.createElement("input", { type: "text", id: "userId0", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.공유하실이메일주소")]), className: (errorList.filter(err => (err.field === "toMails")).length > 0) ? "input-error" : "", value: toMails, onChange: (e) => handleSetUserId(e) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "toMails")).map((err) => err.msg)))))),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => shareClose(e) },
                        React.createElement("span", null, t("LABEL.취소"))),
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => emailShare(e) },
                        React.createElement("span", null, t("LABEL.확인"))))))));
}
/* function UpdataPop(props){
  
  // by 20220819 hjo
   const [resultPutPop, setResultPutPop] = useState(false);
  const [comment, setComment] = useState<string>("");
  const [saveComment, setSaveComment] = useState<string>("");
  // by hjo 20220819
   function onClickComment(e) {
    e.preventDefault();
    if (resultPutPop === false) {
      setResultPutPop(true);
    }
  }
 
  function close(e) {
    if (resultPutPop === true) {
      setResultPutPop(false);
    }
  }
  async function onClickSaveComment(e) {
    onClickComment(e); // for layer close
    let data: any = null;
    data = await HttpUtil.PromiseHttp({
      "httpMethod": "PUT",
      "appPath": `/api/v2/assessment/alarmmsg`,
      "appQuery": {
        "assessmentId": assessmentId,
        "alarmMessage": comment
      },
      userToken: userInfo.loginInfo.token,
    });
    if (data) {
      if (data.codeNum == CONST.API_200) {
        setSaveComment(data.body.alarmMessage);
        close(e)
      }
    }
  }
  return(
    <>
       <div id="pop-edit" className={`pop-edit popup-boxin ${(resultPutPop) ? "on" : ""}`} >
            <div className="page-detail">
              <div className="popup__head">
                <h1>Edit Message</h1>
                <button className="btn btn-close" onClick={(e) => close(e)}><span className="hide">닫기</span></button>
              </div>
              <div className="popup__body">
                <p className="txtnum">{comment.length} / 120</p>
                <textarea id="text" placeholder="의견을 입력하세요." value={comment}
                  onKeyPress={(e) => CUTIL.beforeHandleComment(e, 120)}
                  onKeyUp={(e) => CUTIL.afterHandleComment(e, 120, setComment)}
                  onChange={(e) => setComment(e.target.value)}
                ></textarea>
              </div>
               <!--220610, memo__txt 태그 의견확인일 경우 노출-->
               <!-- <p className="memo__txt">현충일(顯忠日)은 나라를 위해 희생한 순국선열(殉國先烈)과 전몰(戰歿)한 장병들의 충렬을 기리고 얼을 위로하기 위하여 지정된 대한민국의 중요한 기념일이다.중요한 기념일이다.이다.얼을 위로하기 위하여 지정된 대한민국의 중요한 기념일이다.중요한 기념일이다.</p> -->
              <div className="popup__footer">
                <button type="button" onClick={(e) => onClickSaveComment(e)}><span>저장</span></button>
                 <!--220610, 삭제, 수정버튼 의견확인일 경우 노출-->
                <!-- <button type="button" class="bg-gray"><span>삭제</span></button>
                 <button type="button"><span>수정</span></button>
              </div>
            </div>
          </div>
    </>
  );
} */ 
